import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const vkycApi = createApi({
  reducerPath: 'vkycApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL + '/v2/api/' }),
  endpoints: (builder) => ({
    getVkycDetails: builder.query({
      query: (data) => {
        return {
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/vkyc/vkyc-status?jwt_token=${data.jwt_token}&secret=${data.scrt}`,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
        };
      },
    }),
    startVkycVerification: builder.mutation({
      query: (data) => {
        return {
          method: 'GET',
          url: `${process.env.REACT_APP_API_URL}/customers/v1/vkyc/vkyc-status?jwt_token=${data.jwt_token}&secret=${data.scrt}&get_redirection=true`,
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            secret: data.scrt,
            jwt_token: data.jwt_token,
          },
        };
      },
    }),
  }),
});

export const { useGetVkycDetailsQuery, useLazyGetVkycDetailsQuery, useStartVkycVerificationMutation } = vkycApi;